import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import withFeatureFlags, {
  WithFeatureFlagsProps,
} from '@wix/da-react-context/pkg/flags/withFeatureFlags';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import GallectionSimpleView from './GallectionSimpleView';
import GallectionSearchView from './GallectionSearchView';
import GallectionEmptyState from './GallectionsEmptyState';
import { GallectionType } from '../../../../types/gallection';

export interface Props {
  isSectionLoading: boolean;
  hasAnyDeviations: boolean;
  searchQuery: string;
  gallectionType: GallectionType;
}

class GallectionsSection extends React.Component<
  Props & WithTranslation & WithFeatureFlagsProps
> {
  componentDidMount() {
    // we don't do route parsing for gallery using react-router anymore
    // so make the back button simply reload the URL it returns to
    window.addEventListener('popstate', this.reloadPage);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.reloadPage);
  }

  render() {
    const { isSectionLoading, hasAnyDeviations, searchQuery, gallectionType } =
      this.props;

    if (isSectionLoading) {
      return <LoadingIndicator />;
    }

    if (!hasAnyDeviations) {
      return <GallectionEmptyState />;
    }

    if (searchQuery) {
      return <GallectionSearchView />;
    }

    return (
      <BiLoggerContextProvider value={{ sectionname: gallectionType }}>
        <GallectionSimpleView />
      </BiLoggerContextProvider>
    );
  }

  reloadPage = () => {
    window.location.reload();
  };
}

export default withFeatureFlags(withTranslation()(GallectionsSection));
